import React, { useRef, useState } from 'react';
import SignatureCanvas from 'react-signature-canvas';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';
import classes from './tabs.module.scss';
import Button from '../../../../_common/Form/Buttons/Button';

const SignaturePad = ({ onClose, onSave, saveLoading }) => {
  const signPad = useRef(null);

  const [signatureFile, setSignatureFile] = useState(null);

  const [error, setError] = useState(false);

  const addSignature = () => {
    fetch(signPad.current.toDataURL())
      .then((res) => res.blob())
      .then((blob) => {
        const file = new File([blob], 'image.png', { type: 'image/png' });
        setSignatureFile(file);
      });

    setError(false);
  };

  const saveSignature = async () => {
    if (!signatureFile) {
      setError(true);
      toast.error('Please sign');
    } else {
      await onSave(signatureFile);

      onClose();
    }
  };

  const clearSignature = () => {
    signPad.current.clear();
    setSignatureFile(null);
  };

  return (
    <div className={classes.signature_wrapper}>
      <div className={classes.signature_pad_wrapper}>
        <div className={classes.signature_pad_title}>
          <h3>Signature pad</h3>

          <Button
            title="Clear"
            buttonColor="red"
            reverseColor
            className={classes.clear_btn}
            onClick={clearSignature}
          />
        </div>

        <div className={`${classes.signature_canvas_wrapper} ${error ? classes.error : ''}`}>
          <SignatureCanvas
            ref={signPad}
            penColor="black"
            canvasProps={{
              width: 400,
              height: 220,
            }}
            onEnd={addSignature}
          />
        </div>

        <div className={classes.signature_btns_wrapper}>
          <Button
            title="Cancel"
            clearButton
            className={classes.btn}
            onClick={onClose}
          />

          <Button
            title="Accept"
            reverseColor
            loading={saveLoading}
            className={classes.accept_btn}
            onClick={saveSignature}
          />
        </div>
      </div>
    </div>
  );
};

SignaturePad.propTypes = {
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
};

export default SignaturePad;
